import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionsCreators } from "../../actions";
import strings from "../../helpers/Localization";
import { toast } from "react-toastify";

//CUSTOM COMPONENT
import Area from "../../aGlobalDesign/Area/Area";
import PaginationList from "../../aGlobalDesign/Pagination/PaginationList";
import ButtonSkaRound from "../../aGlobalDesign/Buttons/ButtonSkaRound";
import Modal from "../../aGlobalDesign/Modal/Modal";
import AppBar from "../../aGlobalDesign/Modal/AppBar";
import ButtonSKA from "../../aGlobalDesign/Buttons/ButtonSKA";

import Status from "../../aGlobalDesign/Status/Status";

class PortalAgentsList extends React.Component {

    constructor() {
        super();
        this.state = {
            displayParameters: [],
            searchField: "",
            forcePaginationUpdate: 0,
            temporaryElement: null,
            selectedDisplay: null,
            logsList: null,
            adminMenu: null,
            openModalStatus: false,
            selectedStatusElement: null,
            selectModeStatus: { id: "available", name: strings.Available }
        };
    }
    componentDidMount() {
        this.props.changeAppBarTitle(strings.PortalsAgent);
        this.props.ChangeCurrentMenuName("PortalsAgent");
        if (!this.props.monitoring.secondarycallcenters) {
            this.props.GetSecondaryCallCentersList((data) => {});
        }

        let displayParameters = [];
        if (this.props.currentuser.currentorganization.displayParameters !== null) {
            displayParameters = JSON.parse(this.props.currentuser.currentorganization.displayParameters);
            displayParameters.forEach(param => {
                param.value = param.defaultValue;
            });
        }
        this.setState({
            displayParameters: displayParameters
        });
    }
    forcePaginationUpdate() {
        const temp = this.state.forcePaginationUpdate + 1;
        this.setState({
            selectedDisplay: null,
            forcePaginationUpdate: temp
        });
    }
    componentDidUpdate(prevProps) {
        if (this.props.reload && this.props.reload !== prevProps.reload) {
            this.forcePaginationUpdate();
        }
        if (this.props.createNew !== prevProps.createNew) {
            this.OnLoad(null);
        }
    }

    //#region functions
    OnDelete(id, onSuccess) {
        this.props.OpenDialog({
            title: strings.deleteConfirm,
            description: strings.textDeleteItem,
            secondaryLabel: strings.cancel,
            primaryLabel: strings.confirmDelete,
            onPrimaryAction: () => {
                this.props.DeleteDisplay(id, onSuccess);

                this.props.GetSecondaryPortalAgentsList();

                //we refresh the concerned lists to avoid exeptions
                if (this.props.administration.secondaryusers) {
                    this.props.GetSecondaryUsersList((data) => {});
                }
                if (this.props.administration.users) {
                    this.props.GetUsersList(1, 20, "", "", "", "Table", (data) => {});
                }
                if (this.props.administration.invitations) {
                    this.props.GetInvitationsList(1, 20, "", "", "", "Table", (data) => {});
                }
            }
        });
    }

    OnLoad(display) {
        let d = display;
        const orgId = this.props.currentuser.currentorganization.id;
        const cucallCenterId = this.props.currentuser.user.organizationUsers.find((u) => u.organizationId === orgId).callCenterId;

        if (d === null) {
            const callCenterId = this.props.currentuser.accessrights.hasPermission(80, "create") === 20 ? cucallCenterId : null;
            d = {
                id: 0,
                name: "",
                description: "",
                startUI: "",
                uniqueIdentifier: "",
                displayType: this.props.dictionaries.displayTypes.find(dt => dt.id === 10),
                displayTypeId: 10,
                zone: null,
                isPriority: false,
                zoneId: null,
                location: "",
                callCenterId: callCenterId,
                callCenter: null,
                timestamp: null,
                organizationId: this.props.currentuser.currentorganization.id,
                displayParameters: this.state.displayParameters
            };
            const temp = this.CreateTemp(d);
            this.setState({
                selectedDisplay: d,
                temporaryElement: temp
            });
        }
        else {
            this.props.GetDisplay(d.id, (data) => {
                const temp = this.CreateTemp(data);
                this.setState({
                    selectedDisplay: d,
                    temporaryElement: temp
                });
            });
        }
    }
    CreateTemp(element) {
        const temp = {
            id: element.id,
            name: element.name,
            description: element.description,
            uniqueIdentifier: element.uniqueIdentifier,
            location: element.location,
            isPriority: element.isPriority,
            callCenterId: element.callCenterId,
            displayParameters: element.displayParameters
        };
        return temp;
    }
    SaveTemp(temp, element) {
        element.name = temp.name;
        element.description = temp.description;
        element.uniqueIdentifier = temp.uniqueIdentifier;
        element.location = temp.location;
        element.callCenter = temp.callCenter;
        element.callCenterId = temp.callCenterId;
        element.isPriority = temp.isPriority;
        // callCenterId.zoneId = temp.callCenterId;
        element.displayParameters = temp.displayParameters;
        element.timestamp = temp.timestamp;
        return element;
    }
    saveSelectedDisplay() {
        const display = this.state.selectedDisplay;
        this.SaveTemp(this.state.temporaryElement, display);
        if ( display.name === "") {
            this.props.OpenDialog({
                description: strings.alertName,
                primaryLabel: "OK",
                clickOutsideToClose: true
            });
            return;
        }

        const d = {
            id: display.id,
            name: display.name,
            location: display.location,
            description: display.description,
            uniqueIdentifier: display.uniqueIdentifier,
            organizationId: this.props.currentuser.currentorganization.id,
            callCenterId: display.callCenterId,
            isPriority: display.isPriority,
            timestamp: display.timestamp,
            displayTypeId: display.displayTypeId,
            displayGroupId: display.displayGroupId,
            zoneId: display.zoneId,
            displayParameters: display.displayParameters || this.state.displayParameters
        };

        if (display.id === 0) {
            this.props.CreateDisplay(d,
                (id) => {
                    this.forcePaginationUpdate();
                    this.props.GetSecondaryPortalAgentsList();
                });
        }
        else {
            this.props.EditDisplay(
                d,
                (updatedDisplayTimestamp) => {
                    toast.success(strings.successfullSaveDisplay);
                    this.forcePaginationUpdate();
                    this.props.GetSecondaryPortalAgentsList();
                }
            );
        }
    }

    getStatus(stat) {
        const numberStat = Number(stat);
        switch (numberStat) {
            case 60 : return strings.CallInProgress;
            case 45 : return strings.WaitingList;
            case 10 : return strings.OffLine;
            case 20 : return strings.OffLine;
            case 30 : return strings.SleepMode;
            case 40 : return strings.Available;
            case 50 : return strings.IncomingCall;
            case 70 : return strings.BreakMode;
            default : return strings.NoStatus;
        }
    }

    modeSleep(element, mode) {
        this.props.handleSleepMode(Number(element.id), mode, () => {
            this.setState({
                openModalStatus: false,
                selectedStatusElement: null
            });
        });
    }
    //#endregion

    render() {
        const accessrights = this.props.currentuser && this.props.currentuser.accessrights ? this.props.currentuser.accessrights : {};
        const isSystemAdministrator = this.props.currentuser && this.props.currentuser.user && this.props.currentuser.user.isSystemAdministrator;
        return <>
            <PaginationList
                forcePaginationUpdate={this.state.forcePaginationUpdate}

                onGetElements={
                    (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary) =>
                        this.props.GetPortalAgentsList(pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess, secondary)
                }
                onSavePagination={this.props.SavePortalAgentsPagination}
                myElements={this.props.monitoring.portalagents}

                sortOptions={[
                    { sortName: "status", sortData: "null" },
                    { sortName: "name", sortData: "asc" },
                    { sortName: "description", sortData: "null" },
                    { sortName: "callCenter", sortData: "null" },
                    { sortName: "users", sortData: "null" },
                    { sortName: "applicationVersion", sortData: "null" },
                    { sortName: "lastactivity", sortData: "null" }
                ]}

                tableElement={(element, onReloadList) => {
                    return [
                        {
                            colTitle: strings.SortStatus,
                            fixedWidth: "200px",
                            lockWidth: true,
                            sortIndex: 0,
                            cellRenderer: ({ data, column }) => {
                                const value = data[column.field];
                                if (value) {
                                    const isDisabledButtonStatus = !value
                                            || value.portalStatusId === 50
                                            || value.portalStatusId === 60
                                            || value.portalStatusId === 10 && value.modeSleep !== 2
                                            || value.portalStatusId === 20 && value.modeSleep !== 2
                                            || !accessrights
                                            || !accessrights.hasPermission(90, "modify") > 10;
                                    return <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px"
                                        }} >
                                        <div>
                                            <Status
                                                statusId={ value.modeSleep === 2 ? 30 : value.modeSleep === 1 ? 70 : value.portalStatusId}
                                                disabledTooltip={true}
                                            />
                                        </div>
                                        <button disabled={isDisabledButtonStatus}
                                            onClick={() =>
                                                this.setState({
                                                    openModalStatus: true,
                                                    selectedStatusElement: value,
                                                    selectModeStatus: value.modeSleep === 2 ? { id: "sleepMode", name: strings.SleepMode } : { id: "available", name: strings.Available }
                                                })
                                            }
                                            style={{
                                                cursor: isDisabledButtonStatus ? "default" : "pointer",
                                                border: "none",
                                                background: "none",
                                                textDecoration: "underline",
                                                textDecorationColor: isDisabledButtonStatus ? "var(--grey-light)" : "var(--carbone)"
                                            }}>
                                            {this.getStatus(value.modeSleep === 2 ? 30 : value.modeSleep === 1 ? 70 : value.portalStatusId)}
                                        </button>
                                    </div>;
                                }
                                else {return "";}
                            },
                            colContent: element ? {
                                portalStatusId: element.portalStatusId,
                                modeSleep: element.modeSleep,
                                id: element.id
                            } : null
                        },
                        {
                            colTitle: strings.SortName,
                            fixedWidth: "250px",
                            sortIndex: 1,
                            colContent: element ? element.name : null
                        },
                        {
                            colTitle: strings.Description,
                            fixedWidth: "200px",
                            sortIndex: 2,
                            colContent: element ? element.description : null
                        },
                        {
                            colTitle: strings.SortCallCenter,
                            fixedWidth: "200px",
                            sortIndex: 3,
                            colContent: element && element.callCenter ? element.callCenter.name : null
                        },
                        {
                            colTitle: "Est prioritaire (PABX)",
                            colContent: element && element.isPriority ? "Oui" : "Non"
                        },
                        // {
                        //     colTitle: strings.SortDisplayStateUpdate,
                        //     flex: "3",
                        //     sortIndex: 6,
                        //     colContent: element && element.displayStateUpdateDate ? element.displayStateUpdateDate : null
                        // },
                        {
                            colTitle: strings.SortPlayerVersion,
                            fixedWidth: "200px",
                            lockWidth: true,
                            sortIndex: 5,
                            colContent: element && element.applicationVersion !== null && element.webAppVersion !== null ?
                                element.applicationVersion + " (" + element.webAppVersion + ")"
                                :
                                element && element.applicationVersion !== null ?
                                    element.applicationVersion
                                    :
                                    element && element.webAppVersion !== null ?
                                        " (" + element.webAppVersion + ")"
                                        :
                                        null
                        },
                        {
                            colTitle: strings.SortActions,
                            colType: "actions",
                            actions: isSystemAdministrator ? [1, 2, 3, 4] : [1, 2, 3],
                            colContent: [
                                isSystemAdministrator ?
                                    <ButtonSkaRound
                                        key={"actions-admin"}
                                        type="primary"
                                        nameIcon="settings"
                                        onClick={() => this.setState({ adminMenu: {
                                            portalName: element.name,
                                            portalUniqueIdentifier: element.uniqueIdentifier,
                                            commands: ["RestartWebApp", "RestartApp", "RestartDevice", "CheckUpdateForAll", "CheckUpdateForOrga", "CheckUpdateForDevice", "GetTechnicalLogs"]
                                                .map((com) => {return { command: com };})
                                        } })}
                                    /> : null,
                                <ButtonSkaRound
                                    key={"view"}
                                    type="primary"
                                    isDisabled={!accessrights || accessrights.hasPermission(80, "consult") <= 10}
                                    onClick={() => {
                                        this.setState({ preview: true });
                                        this.OnLoad(element);
                                    }}
                                    nameIcon="eye"
                                />,
                                <ButtonSkaRound
                                    key={"edit"}
                                    isDisabled={!accessrights || accessrights.hasPermission(80, "modify") <= 10}
                                    type="primary"
                                    nameIcon="edit"
                                    onClick={() => this.OnLoad(element)}
                                />,
                                <ButtonSkaRound
                                    key={"trash"}
                                    isDisabled={!accessrights || accessrights.hasPermission(80, "delete") <= 10}
                                    type="primary"
                                    nameIcon="trash"
                                    onClick={() => this.OnDelete(element.id, () => this.forcePaginationUpdate())}
                                />
                            ]
                        }
                    ];
                }}
            />
            <Modal open={this.state.selectedDisplay !== null}
                onClose={() => {
                    if (!this.state.preview) {
                        this.forcePaginationUpdate();
                    }
                    else {
                        this.setState({ preview: false, selectedDisplay: null });
                    }
                }}
                title={this.state.preview ? strings.infoIntercom : this.state.selectedDisplay && this.state.selectedDisplay.id !== 0 ? strings.editIntercom : strings.CreateNewPortalAgent}
                icon={this.state.preview ? "information" : this.state.selectedDisplay && this.state.selectedDisplay.id !== 0 ? "edit" : "add"}
                validationIcon={this.state.selectedDisplay && this.state.selectedDisplay.id !== 0 ? "save" : null}
                validationTitle={this.state.selectedDisplay && this.state.selectedDisplay.id !== 0 ? strings.register : null}
                fields={
                    this.state.temporaryElement ? [
                        {
                            type: "textfield",
                            title: strings.name,
                            disabled: this.state.preview,
                            placeholder: strings.newIntercom,
                            value: this.state.temporaryElement.name,
                            onChange: (e) => {
                                const dp = this.state.temporaryElement;
                                dp.name = e.target.value;
                                this.setState({ temporaryElement: dp });
                            }
                        },
                        {
                            type: "textfield",
                            title: strings.Description,
                            disabled: this.state.preview,
                            placeholder: strings.hisDescritif,
                            value: this.state.temporaryElement.description,
                            onChange: (e) => {
                                const dp = this.state.temporaryElement;
                                dp.description = e.target.value;
                                this.setState({ temporaryElement: dp });
                            }
                        },
                        {
                            type: "textfield",
                            title: strings.ID,
                            placeholder: strings.ID,
                            disabled: this.state.isPreview || this.state.temporaryElement.id !== 0,
                            value: this.state.temporaryElement.uniqueIdentifier,
                            onChange: (e) => {
                                const dp = this.state.temporaryElement;
                                dp.uniqueIdentifier = e.target.value;
                                this.setState({ temporaryElement: dp });
                            }
                        },
                        {
                            type: "selectElement",
                            title: strings.CallCenters,
                            openTop: true,
                            disabled: this.state.preview,
                            elementsList: this.props.monitoring.secondarycallcenters,
                            selectedElementId: this.state.temporaryElement.callCenterId,
                            onSelectElement: (element) => {
                                const temp = this.state.temporaryElement;

                                if (accessrights.hasPermission(85, "modify") === 20) {
                                    const cucallCenterId = this.props.currentuser.user.organizationUsers.find((u) => u.organizationId === orgId).callCenterId;
                                    if (element && element.id !== cucallCenterId) {return;}
                                }

                                temp.callCenterId = element ? element.id : null;
                                temp.callCenter = element;
                                this.setState({ temporaryElement: temp });
                            }
                        },
                        {
                            type: "togglebutton",
                            title: "Est prioritaire (PABX)",
                            disabled: this.state.preview,
                            checked: this.state.temporaryElement.isPriority,
                            selectedElementId: this.state.temporaryElement.callCenterId,
                            onClick: () => {
                                const temp = this.state.temporaryElement;

                                if (accessrights.hasPermission(85, "modify") === 20) {
                                    const cucallCenterId = this.props.currentuser.user.organizationUsers.find((u) => u.organizationId === orgId).callCenterId;
                                    if (element && element.id !== cucallCenterId) {return;}
                                }

                                temp.isPriority = !temp.isPriority;
                                this.setState({ temporaryElement: temp });
                            }
                        }
                    ].concat(!isSystemAdministrator ? [] : this.state.temporaryElement.displayParameters.map((displayParam, dpindex) => {
                        if (displayParam.key !== "SizeCapsule") {
                            return {
                                type: "textarea",
                                title: displayParam.key,
                                value: displayParam.value,
                                disabled: this.state.preview,
                                onChange: (e) => {
                                    const dp = this.state.temporaryElement;
                                    dp.displayParameters[dpindex].value = e.target.value;
                                    this.setState({ temporaryElement: dp });
                                }
                            };
                        }
                    })) : null
                }
                onValidate={this.state.selectedDisplay && !this.state.preview ? () => this.saveSelectedDisplay() : null }
            >
            </Modal>
            <Modal open={this.state.adminMenu !== null}
                onClose={() => this.setState({ adminMenu: null })}
                title={(this.state.adminMenu ? this.state.adminMenu.portalName : "") + " - Admin"}
                icon={"settings"}
            >
                {this.state.adminMenu ?
                    <>
                        {
                            this.state.adminMenu.commands.map((el) => {
                                return <ButtonSKA
                                    key={el.command}
                                    disabled={!this.props.communication || !this.props.communication.webRTConnection }
                                    type="primary"
                                    text={el.command}
                                    onClick={() => {
                                        console.log("invoke ==> SendAdminCommand", this.state.adminMenu.portalUniqueIdentifier + " ; " + el.command);
                                        this.props.communication.webRTConnection.invoke("SendAdminCommand", this.state.adminMenu.portalUniqueIdentifier, el.command);
                                        toast.success(`${el.command} OK`);
                                    }}
                                />;
                            })
                        }
                        <ButtonSKA
                            disabled={!this.props.communication || !this.props.communication.webRTConnection }
                            type="primary"
                            text={strings.ShowAllLogs}
                            onClick={() => {
                                this.props.GetDisplayLogs(this.state.adminMenu.portalUniqueIdentifier, (logs) => {
                                    this.setState({ logsList: logs });
                                });
                            }}
                        />
                    </>
                    : null}
            </Modal>
            <Modal open={this.state.logsList !== null}
                onClose={() => this.setState({ logsList: null })}
                title={(this.state.adminMenu ? this.state.adminMenu.portalName : "") + " - Logs"}
                icon={"settings"}
            >
                {this.state.adminMenu && this.state.logsList ? this.state.logsList.length <= 0 ?
                    strings.NoLogsInStorage
                    :
                    <AppBar
                        slides={[
                            {
                                title: "Logs UWP",
                                content: <>
                                    {
                                        this.state.logsList.slice().reverse().map((log, index) => {
                                            return log.includes("/UWP") ?
                                                <a key={index} href={log}>{log}</a>
                                                :
                                                null;
                                        })
                                    }
                                </>
                            },
                            {
                                title: "Logs WebApp",
                                content: <>
                                    {
                                        this.state.logsList.slice().reverse().map((log, index) => {
                                            return log.includes("/webapp") ?
                                                <a key={index} href={log}>{log}</a>
                                                :
                                                null;
                                        })
                                    }
                                </>
                            }
                        ]}/> : null}
            </Modal>
            <Modal open={this.state.openModalStatus}
                onClose={() => this.setState({
                    openModalStatus: false
                })}
                title={strings.StatusIntercom}
                icon={"tool"}
                validationTitle={strings.confirmButton}
                fields={ [
                    {
                        type: "selectElement",
                        preventEmpty: true,
                        elementsList: { results: [
                            { id: "available", name: strings.Available },
                            { id: "sleepMode", name: strings.SleepMode }
                        ] },
                        value: this.state.selectModeStatus,
                        selectedElementId: this.state.selectModeStatus.id,
                        onSelectElement: (element) => {
                            this.setState({ selectModeStatus: element });
                        }
                    },
                    this.state.selectModeStatus ?
                        {
                            type: "custom",
                            child: <p style={{ fontSize: "14px", fontWeight: 400, margin: 0 }}>
                                {
                                    this.state.selectModeStatus.id === "sleepMode" ?
                                        strings.MessageStatusSleepModeIntercom
                                        :
                                        strings.MessageStatusAvailableIntercom
                                }
                            </p>
                        }
                        :
                        null
                ]}
                onValidate={() => {
                    const el = this.state.selectedStatusElement;
                    const selectedStatus = this.state.selectModeStatus.id;
                    if (!el) {return;}

                    if (selectedStatus === "available") {this.modeSleep(el, 0);}
                    else if (selectedStatus === "sleepMode") {this.modeSleep(el, 2);}
                }}

            >
            </Modal>
        </>;
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(PortalAgentsList);
